import Category from './Category.vue'

export default Category
